// extracted by mini-css-extract-plugin
module.exports = {"container":"_76O6QDH3veUPwTYwKTGBhw==","image":"C7C4dVDKTo-02rwZAdzspQ==","slogan":"PBT7Qvj+zfHZwJOal-twyw=="};